import { Channel, ChannelPayloadFilter } from "spyne";
import { CodeContainerTraits } from "../traits/code-container-traits";
import { take } from "rxjs/operators";

export class ChannelCodeContainer extends Channel {
  constructor(name, props = {}) {
    name = "CHANNEL_CODE_CONTAINER";
    props.traits = [CodeContainerTraits];
    props.sendCachedPayload = true;

    super(name, props);
  }

  onRouteChangeEvent(e) {
    const { routeData, pathsChanged, pathsRemoved, pathInnermost } = e.payload;
    const { pageId, typeId, exampleId } = routeData;

    const updateInitialClassMethod = ["pageId", "stage"].every((s) =>
      pathsChanged.includes(s),
    );
    const updateClassMethod =
      pathsChanged.includes("classMethod") && pathInnermost === "classMethod";
    //console.log("CLASS METHOD NEXT ",{pathsChanged,pathsRemoved, routeData, pathInnermost, routeData},e.payload);

    const isDocsExample =
      routeData?.pageId === "docs" && routeData?.stage === "examples";

    if (pageId === "getting-started") {
      const vsid = this.codeContainer$GetContainerVsid(e);

      const payload = this.codeContainer$GetChannelPayload(
        typeId,
        exampleId,
        vsid,
      );
      //payload.vsid = vsid;

     //console.log("CODE CONTAINER ",{pageId, vsid, typeId, exampleId, routeData, pathsChanged, pathInnermost}, this.props.data);

      const action = "CHANNEL_CODE_CONTAINER_UPDATE_EVENT";

      this.sendChannelPayload(action, payload);
    } else if (updateInitialClassMethod === true) {
      const action = "CHANNEL_CODE_CONTAINER_ROUTE_EVENT";
      const onRouteEvent = () => this.sendChannelPayload(action, routeData);
      requestAnimationFrame(onRouteEvent);
    } else if (updateClassMethod) {
      let requestPayload = routeData;

      // History navigation within reference: the URL carries the class
      // (stage) and method slug (classMethod) but none of the dataset
      // params a method link would send — resolve them from codeGenData.
      if (!routeData.methodName) {
        const refState = this.codeContainer$GetReferenceStateByRoute(
          routeData,
        );
        if (refState !== undefined) {
          requestPayload = { ...routeData, ...refState };
        }
      }

      this.onRequestData(requestPayload, 'onRouteChangeEvent');
    } else if (isDocsExample) {
      let requestPayload = routeData;

      // Browser history navigation re-derives routeData from the URL
      // alone, so the methodName/codeBlockId a menu link carries in its
      // dataset are absent and the request would be dropped — resolve the
      // example's load params from the docs data by container instead.
      if (!routeData.methodName && routeData.container) {
        const exampleItem = this.codeContainer$GetDocsExampleByContainer(
          routeData.container,
        );
        if (exampleItem !== undefined) {
          requestPayload = {
            ...routeData,
            codeBlockId: exampleItem.codeBlockId,
            methodName: exampleItem.methodName,
            exampleTitle: exampleItem.exampleTitle,
            codeBlockDataSection: exampleItem.codeBlockDataSection ?? "types",
          };
        }
      }

      this.onRequestData(requestPayload, 'routeIsDocsExample');
    }
  }

  onContainerDataRequest(e) {
    this.onRequestData(e.payload, 'onContainerDataRequest');
  }

  onRequestData(requestPayload, requestType="undefined") {
    // const {srcElement} = e;
    //  const {el} = srcElement;
    //const {num, prevNum} = el.dataset;



    const {
      codeBlockId,
      methodName,
      sectionTitle,
      codeBlockStateName,
      initialLoad,
      codeBlockDataSection,
      num,
      prevNum,
    } = requestPayload;

    if (requestType === 'routeIsDocsExample' && !methodName) {
      //console.log('not valid code container call ', {requestPayload, requestType})
      return;
    }

    //const vsid = this.codeContainer$GetContainerVsid(e);
    //console.log("REQUEST DATA ", {requestPayload, requestType, codeBlockId, methodName, sectionTitle, codeBlockStateName, initialLoad, codeBlockDataSection, num, prevNum});

    const payload = this.codeContainer$GetChannelPayload({
      codeBlockId,
      codeBlockStateName,
      codeBlockDataSection,
      initialLoad,
      methodName,
      num,
      sectionTitle,
      prevNum,
    });

    // Unresolvable request — nothing to update (e.g. a route without
    // resolvable data-section params). Never crash the pipeline.
    if (payload === undefined) {
      return;
    }

    const action = "CHANNEL_CODE_CONTAINER_UPDATE_EVENT";

/*   console.log("CHANNEL CONTAINER UPDATE ", {
      codeBlockId,
      methodName,
      codeBlockStateName,
      payload,
      requestPayload
    });*/


    this.sendChannelPayload(action, payload);
  }

  onDataReceived(e) {
    const { payload } = e;

    //console.log("CODE RECEIVED ",{payload})
    // this.props.data = this.sidebar$ConformSidebarData(payload);

    this.props.data = payload.codeGenData;
    // Flattened docs items — used to resolve an example's load params
    // when a route arrives without them (browser history navigation).
    this.props.docsContent = payload.spyneDocsData?.docsContent;

    this.getChannel("CHANNEL_ROUTE").subscribe(
      this.onRouteChangeEvent.bind(this),
    );
  }

  onButtonClicked(e) {
    const { eventType } = e.payload;

    if (eventType === "scriptContent") {
      this.onCodeRevealEventRequest(e);
    } else {
      this.onRequestData(e.payload);
    }
  }

  onRegistered() {
    this.getChannel("CHANNEL_SPYNE_DOCS_DATA")
      .pipe(take(1))
      .subscribe(this.onDataReceived.bind(this));

    const codePlaygroundFilter = new ChannelPayloadFilter({
      buttonType: "codePlayground",
    });

    this.getChannel("CHANNEL_UI", codePlaygroundFilter).subscribe(
      this.onButtonClicked.bind(this),
    );
  }

  onPropertiesContentAdded(e) {
    const { payload } = e;
    const action = "CHANNEL_CODE_CONTAINER_PROPERTIES_CONTENT_UPDATED";
    //console.log('properties updated ',{payload, action})

    const onSendUpdated = () => this.sendChannelPayload(action, payload);
    requestAnimationFrame(onSendUpdated);
  }

  onCodeRevealEventRequest(e) {
    const { payload } = e;
    const action = "CHANNEL_CODE_CONTAINER_CODE_REVEAL_EVENT";
    this.sendChannelPayload(action, payload);
    //codeContainer$HelloWorld
  }

  onContainerStyleUpdate(e) {
    // payload should contain styleType, styleKey, styleValue, parentVsid
    const { payload } = e;
    const action = "CHANNEL_CODE_CONTAINER_STYLE_UPDATE_EVENT";

   //console.log("STYLE UPDATE ",e, payload, action);
    this.sendChannelPayload(action, payload);
  }

  addRegisteredActions() {
    return [
      "CHANNEL_CODE_CONTAINER_UPDATE_EVENT",
      ["CHANNEL_CODE_CONTAINER_TESTER_EVENT", "codeContainer$HelloWorld"],
      "CHANNEL_CODE_CONTAINER_ROUTE_EVENT",
      "CHANNEL_CODE_CONTAINER_STYLE_UPDATE_EVENT",
      [
        "CHANNEL_CODE_CONTAINER_STYLE_UPDATE_REQUEST_EVENT",
        "onContainerStyleUpdate",
      ],
      "CHANNEL_CODE_CONTAINER_PROPERTIES_CONTENT_UPDATED",
      [
        "CHANNEL_CODE_CONTAINER_PROPERTIES_CONTENT_ADDED",
        "onPropertiesContentAdded",
      ],
      ["CHANNEL_CODE_CONTAINER_REQUEST_UPDATE_EVENT", "onContainerDataRequest"],
      "CHANNEL_CODE_CONTAINER_CODE_REVEAL_EVENT",
      [
        "CHANNEL_CODE_CONTAINER_CODE_REVEAL_EVENT_REQUEST",
        "onCodeRevealEventRequest",
      ],
    ];
  }

  onViewStreamInfo(obj) {
    //console.log("OBJ IS ", obj);

    // let data = obj.props();
  }
}
